"use client";

import styles from "./map.module.scss";
import { Suspense } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <main className={styles.pageContainer}>
      <h1 className="tw-mb-4 tw-text-xl md:tw-text-2xl">Map</h1>
      <Suspense fallback={<p></p>}>
        <p>
          We ran into some issues loading the map, please try again later...
        </p>
      </Suspense>
    </main>
  );
}
